import { render, staticRenderFns } from "./mergeOrder.vue?vue&type=template&id=431d3a0a"
import script from "./mergeOrder.vue?vue&type=script&lang=js"
export * from "./mergeOrder.vue?vue&type=script&lang=js"
import style0 from "./mergeOrder.vue?vue&type=style&index=0&id=431d3a0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports